import React, { useEffect, useState } from "react";
import {
  Tabs,
  Tab,
  Box,
  Button,
  Typography,
  TextField,
  Checkbox,
  RadioGroup,
  ListItem, Radio,
  List,
  FormControlLabel,
  Avatar,
  ListItemText,
  Grid,
} from "@mui/material";
import { MenuItem, Select, InputLabel, FormControl } from "@mui/material";
import { TiMessages } from "react-icons/ti";
import { MdMailOutline } from "react-icons/md";
import { MdOutlineWhatsapp } from "react-icons/md";
import { Modal, Form } from "react-bootstrap";
import axios from "axios";
import toast, { Toaster } from 'react-hot-toast';
import { GoDotFill, GoUpload } from "react-icons/go";
import {
  MdOutlineDone,
  MdOutlinePhoneEnabled,
  MdExpandMore,
  MdExpandLess,
} from "react-icons/md";
import { Link } from "react-router-dom";
import pdf from "../../../../assets/images/pdf.png";
import './Style1.css';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { AiOutlineDown, AiOutlineUp } from 'react-icons/ai';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css'
import { CountryDropdown, RegionDropdown } from 'react-country-region-selector';
import { useProjectName } from "../../../../Context/ProjectNameContext";
import { useTranslation } from "react-i18next";
import { getToken } from "../../../../utils/auth";
import validateEmail from "../../../../utils/validateEmail";
import validatePhoneNumber from "../../../../utils/validatePhoneNumber";
import { CircularProgress } from "@mui/material";
import { Country, State } from 'country-state-city';
import { getName } from "country-list";

const Stepper = ({available, handleTabChangeMain}) => {
  const projectName = useProjectName();
  const { t, i18n } = useTranslation();
  const [step, setStep] = useState(1);
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [profileOption, setProfileOption] = useState("");
  const [category, setCategory] = useState({ name: "", description: "" });
  const [categories, setCategories] = useState([
    { name: "Electronics", description: "Devices and gadgets" },
    { name: "Books", description: "Various genres of books" },
    { name: "Furniture", description: "Home and office furniture" },
  ]);
const [userAllDetail, setUserAllDetail] = useState("")
  const fetchUserData = async () => {
    try {
      const token = getToken();
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/user`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setUserAllDetail(response?.data?.data);
    } catch(error) {
      console.error("Failed Fetching Details", error);
    }
  };

  useEffect(() => {
    fetchUserData();
  }, []);

  const dialogStyles = {
    paper: {
      minWidth: '500px',
      padding: '16px',
    },
  };

  const buttonStyles = {
    cancelButton: {
      color: '#3f51b5', 
    },
    deleteButton: {
      color: 'white',
      backgroundColor: 'red',
      '&:hover': {
        backgroundColor: 'darkred',
      },
    },
  };

  const [condition, setCondition] = useState({
    category: "",
    name: "",
    description: "",
  });
  // const [contacts, setContacts] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [selectedTab, setSelectedTab] = useState(0);
  const [selectedTab1, setSelectedTab1] = useState(0);
  const [selectedTab2, setSelectedTab2] = useState(0);
  const [categoryName, setCategoryName] = useState("");
  const [categoryDescription, setCategoryDescription] = useState("");
  const [isAddingCategory, setIsAddingCategory] = useState(false);
  const [communicationChannel, setCommunicationChannel] = useState({
    enableSMS: false,
    enableEmail: false,
    enableWhatsapp: false
});

useEffect(() => {
  const fetchCommunicationChannel = async () => {
    const token = getToken();

      try {
          const response = await axios.get(`${process.env.REACT_APP_URL}/api/communication-channel`, {
              headers: {
                  Authorization: `Bearer ${token}`
              }
          });
          setCommunicationChannel(response.data.data.communicationChannelSettings.communicationChannel);
      } catch (error) {
          console.error('Error fetching communication channel data:', error);
      }
  };

  fetchCommunicationChannel();
}, []);

const handleToggle = async (channel) => {
  const updatedChannel = {
      ...communicationChannel,
      [channel]: !communicationChannel[channel]
  };

  setCommunicationChannel(updatedChannel);
  const token = getToken();

  try {
      const response = await axios.put(`${process.env.REACT_APP_URL}/api/communication-channel`, {communicationChannel:updatedChannel}, {
          headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json'
          }
      });
  } catch (error) {
      console.error('Error updating communication channel:', error);
      // Optionally revert the change if the PUT request fails
      setCommunicationChannel({
          ...communicationChannel,
          [channel]: !updatedChannel[channel]
      });
  }
};


  const [files, setFiles] = useState({
    images: [],
    pdfs: [],
    voiceNotes: [],
    advice: "",
  });

  const [isAddingCondition, setIsAddingCondition] = useState(false);
  const [conditions, setConditions] = useState([
    {
      category: "Electronics",
      name: "Warranty",
      description: "2 years warranty",
      file: "warranty.pdf",
    },
    {
      category: "Books",
      name: "Return Policy",
      description: "14 days return",
      file: "return_policy.pdf",
    },
  ]);
  const [categoryOptions, setCategoryOptions] = useState([
    "Electronics",
    "Books",
    "Furniture",
  ]);
  const [selectedCategory, setSelectedCategory] = useState("");

  const [conditionDescription, setConditionDescription] = useState("");
  const [file, setFile] = useState(null);
  const [selectedConditions, setSelectedConditions] = useState([]);

  const handleAddCondition = () => {
    setIsAddingCondition(true);
  };

  const handleSaveCondition = () => {
    if (selectedCategory && conditionName && conditionDescription && file) {
      setConditions([
        ...conditions,
        {
          category: selectedCategory,
          name: conditionName,
          description: conditionDescription,
          file: file.name,
        },
      ]);
      setSelectedCategory("");
      setConditionName("");
      setConditionDescription("");
      setFile(null);
      setIsAddingCondition(false);
    }
  };

  const handleCancelAddCondition = () => {
    setSelectedCategory("");
    setConditionName("");
    setConditionDescription("");
    setFile(null);
    setIsAddingCondition(false);
  };

  const handleSelectCondition = (conditionName) => {
    setSelectedConditions((prev) => {
      if (prev.includes(conditionName)) {
        return prev.filter((name) => name !== conditionName);
      } else {
        return [...prev, conditionName];
      }
    });
  };

  const handleProceed = () => {
    if (selectedConditions.length > 0) {
      alert("Proceeding to the next step...");
    } else {
      alert("Please select at least one condition before proceeding.");
    }
  };

  // const handleNext = () => {
  //   if (step < 6) setStep(step + 1);
  // };
  const handleNext = async () => {
    if (step === 1) {
      await handleAcceptTermsCondition();
    } else {
      setStep((prevStep) => prevStep + 1);
    }
  };

  const handleBack = () => {
    if (step > 1) setStep(step - 1);
  };

  const handleDone = () => {
    // alert("Process Completed");
    // setTermsAccepted(false);
    setStep(2);
    handleTabChangeMain("second")
  };

  const handleTermsChange = () => {
    setTermsAccepted(!termsAccepted);
  };

  const handleProfileOptionChange = (option) => {
    setProfileOption(option);
  };

  const handleCategoryChange = (e) => {
    const { name, value } = e.target;
    setCategory({ ...category, [name]: value });
  };

  const handleConditionChange = (e) => {
    const { name, value } = e.target;
    setCondition({ ...condition, [name]: value });
  };

  const handleContactChange = (e) => {
    // Logic to add or edit contacts
  };

  // const handleChannelChange = (e) => {
  //   const { name, checked } = e.target;
  //   setCommunicationChannels({ ...communicationChannels, [name]: checked });
  // };

  const handleFileUpload = (type, files) => {
    setFiles({ ...files, [type]: files });
  };

  const handleOptionSelect = (option) => {
    setSelectedOption(option);
  };

  const handleTabChange1 = (event, newValue) => {
    setSelectedTab1(newValue);
  };
  const handleTabChange2 = (event, newValue) => {
    setSelectedTab2(newValue);
  };

  const handleAddCategory = () => {
    setIsAddingCategory(!isAddingCategory);
  };

  const handleSaveCategory = () => {
    setCategories([
      ...categories,
      { name: categoryName, description: categoryDescription },
    ]);
    setCategoryName("");
    setCategoryDescription("");
    setIsAddingCategory(false);
  };

  const handleCancelAddCategory = () => {
    setCategoryName("");
    setCategoryDescription("");
    setIsAddingCategory(false);
  };

  const [isAddingContact, setIsAddingContact] = useState(false);
  const [contacts, setContacts] = useState([
    {
      firstName: "John",
      lastName: "Doe",
      email: "john.doe@example.com",
      phoneNumber: "123-456-7890",
      relationship: "Friend",
    },
    {
      firstName: "Jane",
      lastName: "Doe",
      email: "jane.doe@example.com",
      phoneNumber: "987-654-3210",
      relationship: "Sister",
    },
  ]);

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [relationship, setRelationship] = useState("");
  // const [formData, setFormData] = useState({
  //   name: "",
  //   phone1: "",
  //   phone2: "",
  //   email1: "",
  //   email2: "",
  //   addressline1: "",
  //   addressline2: "",
  //   city: "",
  //   state: "",
  //   zipCode: "",
  //   country: userAllDetail.country,
  //   bloodType: "",
  //   birthDate: "",
  //   note: "",
  //   profilePhoto: null,
  // });
  //   const handleTabChange = (event, newValue) => {
  //               setFormData({
  //       name: "",
  //       phone1: "",
  //       phone2: "",
  //       email1: "",
  //       email2: "",
  //       addressline1: "",
  //       addressline2: "",
  //       city: "",
  //       state: "",
  //       zipCode: "",
  //       country: userAllDetail.country,
  //       bloodType: "",
  //       birthDate: "",
  //       note: "",
  //       profilePhoto: null,
  //     });
  //   setSelectedTab(newValue);
  // };
  const getInitialFormData = (countryValue = "") => ({
  name: "",
  phone1: "",
  phone2: "",
  email1: "",
  email2: "",
  addressline1: "",
  addressline2: "",
  city: "",
  state: "",
  zipCode: "",
  country: countryValue,
  bloodType: "",
  birthDate: "",
  note: "",
  profilePhoto: null,
});
const [formData, setFormData] = useState(() =>
  getInitialFormData(userAllDetail?.country || "")
);
useEffect(() => {
  if (userAllDetail?.country) {
    const countryName = getName(userAllDetail.country) || userAllDetail.country;
    setFormData((prev) => ({
      ...prev,
      country: countryName,
    }));
  }
}, [userAllDetail]);
const handleTabChange = (event, newValue) => {
  const countryName = getName(userAllDetail.country) || userAllDetail.country;
  setFormData(getInitialFormData(countryName));
  setSelectedTab(newValue);
};


  const [selectedContact, setSelectedContact] = useState(null);

  const handleAddContact = () => {
    setIsAddingContact(true);
  };

  const handleSaveContact = () => {
    setContacts([
      ...contacts,
      { firstName, lastName, email, phoneNumber, relationship },
    ]);
    setFirstName("");
    setLastName("");
    setEmail("");
    setPhoneNumber("");
    setRelationship("");
    setIsAddingContact(false);
  };

  const handleCancelAddContact = () => {
    setIsAddingContact(false);
  };

  const [isAddingCredits, setIsAddingCredits] = useState(false);
  const [credits, setCredits] = useState("");

  const handleSelectContact = (contact) => {
    setSelectedContact(contact);
  };

  const handleAddCreditsClick = () => {
    setIsAddingCredits(true);
  };

  const handleSaveCredits = () => {
    alert(`Credits Added: ${credits}`);
    setCredits("");
    setIsAddingCredits(false);
  };

  const handleCancelAddCredits = () => {
    setIsAddingCredits(false);
    setCredits("");
  };

  const [conditionAll, setConditionAll] = useState(null);
  const [categoryAll, setCategoryAll] = useState(null);

  const handleGetAllCategory = async () => {
    try { 
      const token = getToken();
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/category/all`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setCategoryAll(response?.data?.data);
    } catch (error) {
      console.log("Failed Fetching Category", error);
    }
  };

  const handleGetAllConditions = async () => {
    try {
      const token = getToken();
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/condition/all`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setConditionAll(response?.data?.data);
    } catch (error) {
      console.log("Failed Fetching Conditions", error);
    }
  };
  useEffect(() => {
    handleGetAllCategory();
    handleGetAllConditions();
    handleGetAllContacts();
    // handleGetAdvice();
    // handleUpcoming();
  }, []);

  const [profilePic, setProfilePic] = useState('/profile.png'); 

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setProfilePic(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const closeUser = () => {
    setProfileContact(false);
    setProfileContact1(false);
    setProfile(false);
  }
  const renderDummyDetails = () => {
    const containerStyle = {
      padding: '20px',
      maxWidth: '600px',
      margin: 'auto',
      fontFamily: 'Arial, sans-serif',
      borderRadius: '12px',
      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    };
  
    const labelStyle = {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '15px',
    };
  
    const headingStyle = {
      width: '150px',
      fontWeight: 'bold',
    };
  
    const inputStyle = {
      flexGrow: 1,
      padding: '8px',
      borderRadius: '8px',
      border: '1px solid #ccc',
      fontSize: '14px',
    };
  
    const imageStyle = {
      width: '100px',
      height: '100px',
      borderRadius: '50%',
      marginRight: '15px',
      justifyContent:"center",
      display:"flex",
      objectFit: 'cover',
      border: '1px solid #ccc',
    };
  
    const fileInputStyle = {
      flexGrow: 1,
    };
  
    return (
      <div style={containerStyle}>
        <div style={labelStyle}>
          <label style={headingStyle}>{t('name_label')}:</label>
          <input type="text" defaultValue="John Doe" style={inputStyle} />
        </div>
        <div style={labelStyle}>
          <label style={headingStyle}>{t('dob')}:</label>
          <input type="date" defaultValue="1990-01-01" style={inputStyle} />
        </div>
        <div style={labelStyle}>
          <label style={headingStyle}>{t('blood_group')}:</label>
          <input type="text" defaultValue="O+" style={inputStyle} />
        </div>
       
        <div style={labelStyle}>
          <label style={headingStyle}>{t('address')}:</label>
          <input type="text" defaultValue="123 Main St, Springfield" style={inputStyle} />
        </div>
        <div style={labelStyle}>
          <label style={headingStyle}>{t('city')}:</label>
          <input type="text" defaultValue="Delhi" style={inputStyle} />
        </div>
        <div style={labelStyle}>
          <label style={headingStyle}>{t('country')}:</label>
          <input type="text" defaultValue="India" style={inputStyle} />
        </div>
        <div style={labelStyle}>
          <label style={headingStyle}>{t('phone_label')}:</label>
          <input type="tel" defaultValue="(123) 456-7890" style={inputStyle} />
        </div>
        <div style={labelStyle}>
          <label style={headingStyle}>{t('phone_label')} 2:</label>
          <input type="tel" defaultValue="(123) 456-7891" style={inputStyle} />
        </div>
        <div style={labelStyle}>
          <label style={headingStyle}>{t('email_label')}:</label>
          <input type="email" defaultValue="johndoe@example.com" style={inputStyle} />
        </div>
        <div style={labelStyle}>
          <label style={headingStyle}>{t('email_2')}:</label>
          <input type="email" defaultValue="johndoe2@example.com" style={inputStyle} />
        </div>
        <div style={labelStyle}>
          <label style={headingStyle}>{t('note')}:</label>
          <input type="text" defaultValue="This is a dummy profile." style={inputStyle} />
        </div>
        <div style={labelStyle}>
          <label style={headingStyle}>{t('profile_picture')}:</label>
          <input type="file" onChange={handleImageChange} style={inputStyle} />
        </div>
        <div  style={{justifyContent:"center", display:"flex"}}>
          <img src={profilePic} alt="Profile" style={imageStyle} />
        </div>
        <Box display="flex" justifyContent="flex-end" mt={2}>
          <Button
            variant="contained"
            color="primary"
            // onClick={handleSubmit}
          >
            {t('save')}
          </Button>
          <Button
            variant="contained"
            color="primary"
            style={{marginLeft:"10px"}}
            onClick={closeUser}
          >
            {t('cancel')}
          </Button>
        </Box>
      </div>
    );
  };
  
  

  const handleChangeEdit = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  const [contactLoading, setContactLoading] = useState(false);

  const handleSubmitUpdate = async () => {
     if (
        !formData.name 
      ) {
        toast.error("Name is required fields.");
        return;
      }
      if (
        !formData.phone1 
      ) {
        toast.error("Phone1 is required fields.");
        return;
      }
    if (
      !formData.name ||
      !formData.birthDate ||
      !formData.bloodType ||
      !formData.country ||
      !formData.city ||
      !formData.state ||
      !formData.zipCode ||
      !formData.addressline1 ||
      !formData.phone1 ||
      !formData.email1
    ) {
      toast.error("Please fill all required fields.");
      return; 
    }
    
    setContactLoading(true);
      if (formData.email1 && !(await validateEmail(formData.email1))) {
    toast.error("Email 1 is invalid.");
    setContactLoading(false);
    return;
  }
  if (formData.email2 && !(await validateEmail(formData.email2))) {
    toast.error("Email 2 is invalid.");
    setContactLoading(false);
    return;
  }
  if (formData.phone1 && !(await validatePhoneNumber(formData.phone1))) {
    toast.error("Phone 1 is invalid.");
    setContactLoading(false);
    return;
  }
  if (formData.phone2 && !(await validatePhoneNumber(formData.phone2))) {
    toast.error("Phone 2 is invalid.");
    setContactLoading(false);
    return;
  }

    try {
      const token = getToken();

      const response = await axios.put(
        `${process.env.REACT_APP_URL}/api/userprofile/${expandedUserId}`,
        {
          name: formData.name,
          birthDate: formData.birthDate,
          bloodType: formData.bloodType,
          country: formData.country,
          address: {
            city: formData.city,
            state: formData.state,
            zipCode: formData.zipCode,
            addressline1: formData.addressline1,
            addressline2: formData.addressline2,
          },
          phone1: formData.phone1,
          phone2: formData.phone2,
          email1: formData.email1,
          email2: formData.email2,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      toast.success("Profile Updated Successfully!");
      setExpandedUserId(null);
      setExpandedUserDetails(null);
      handleGetAllUsers();
            setIsEditing(false);
      setFormData({
        name: "",
        phone1: "",
        phone2: "",
        email1: "",
        email2: "",
        addressline1: "",
        addressline2: "",
        city: "",
        state: "",
        zipCode: "",
        country: "",
        bloodType: "",
        birthDate: "",
        note: "",
        profilePhoto: null,
      });
          } catch (error) {
      toast.error(error.response?.data?.message || "Failed to update profile");
      console.error("Error updating profile:", error);
    } finally{
      setContactLoading(false);
    }
  };
//     useEffect(() => {
//   if (userAllDetail?.country && !formData.country) {
//     const countryName = getName(userAllDetail.country) || userAllDetail.country;
//     setFormData((prev) => ({ ...prev, country: countryName }));
//   }
// }, [userAllDetail]);
  const renderCreateContactForm = (userAllDetail) => {

    const handleChange = (e) => {
      const { name, value } = e.target;
      setFormData({ ...formData, [name]: value });
    };
  
    const handleFileChange = (e) => {
      setFormData({ ...formData, profilePhoto: e.target.files[0] });
    };
  
    const handleSubmit = async () => {
      if (
        !formData.name 
      ) {
        toast.error("Name is required fields.");
        return;
      }
      if (
        !formData.phone1 
      ) {
        toast.error("Phone1 is required fields.");
        return;
      }
      if (
        !formData.name ||
        !formData.birthDate ||
        !formData.bloodType ||
        !formData.country ||
        !formData.city ||
        !formData.state ||
        !formData.zipCode ||
        !formData.addressline1 ||
        !formData.phone1 ||
        !formData.email1
      ) {
        toast.error("Please fill all required fields.");
        return;
      }
            if (
        !formData.state 
      ) {
        toast.error("State is required fields.");
        return;
      }
       setContactLoading(true);

           if (formData.email1 && !(await validateEmail(formData.email1))) {
    toast.error("Email 1 is invalid.");
    setContactLoading(false);
    return;
  }
  if (formData.email2 && !(await validateEmail(formData.email2))) {
    toast.error("Email 2 is invalid.");
    setContactLoading(false);
    return;
  }
  if (formData.phone1 && !(await validatePhoneNumber(formData.phone1))) {
    toast.error("Phone 1 is invalid.");
    setContactLoading(false);
    return;
  }
  if (formData.phone2 && !(await validatePhoneNumber(formData.phone2))) {
    toast.error("Phone 2 is invalid.");
    setContactLoading(false);
    return;
  }
      try {
        const token = getToken();
    
        let profilePhotoLink = "";
    
        // Only attempt to upload the file if it exists
        if (formData.profilePhoto) {
          const fileData = new FormData();
          fileData.append("file", formData.profilePhoto);
    
          const fileResponse = await axios.post(
            `${process.env.REACT_APP_URL}/api/file/upload`,
            fileData,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          profilePhotoLink = fileResponse.data.data;
        }
    
        // Make the second API call
        const response = await axios.post(
          `${process.env.REACT_APP_URL}/api/userprofile`,
          {
            name: formData.name,
            birthDate: formData.birthDate,
            bloodType: formData.bloodType,
            country: formData.country,
            address: {
              city: formData.city,
              state: formData.state,
              zipCode: formData.zipCode,
              addressline1: formData.addressline1,
              addressline2: formData.addressline2,
            },
            profilePhotoLink,
            phone1: formData.phone1,
            phone2: formData.phone2,
            email1: formData.email1,
            email2: formData.email2,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
    
        toast.success("Profile Saved Successfully!");
        handleGetAllUsers();
    
        setFormData({
          name: "",
          phone1: "",
          phone2: "",
          email1: "",
          email2: "",
          addressline1: "",
          addressline2: "",
          city: "",
          state: "",
          zipCode: "",
          country: "",
          bloodType: "",
          birthDate: "",
          note: "",
          profilePhoto: null,
        });
      } catch (error) {
        toast.error(error.response?.data?.message || "Failed to save profile");
        console.error("Error saving profile:", error);
      }  finally {
    setContactLoading(false);
  }
    };
    
  
    const handlePhoneChange = (phone, field) => {
      setFormData({ ...formData, [field]: phone });
    };


    const selectCountry = (val) => {
      setFormData({ ...formData, country: val, state: '' });
    };
  
    const selectState = (val) => {
      setFormData((prevState) => ({
        ...prevState,
        state: val,
      }));
    };
    


    return (
      <Box component="form" style={{marginTop:"20px"}}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              label={t('name_label')}
              name="name"
              variant="outlined"
              fullWidth
              required
              value={formData.name}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={6}>
      <PhoneInput
          country={(userAllDetail?.country || "us").toLowerCase()} 
        value={formData.phone1}
        onChange={phone => handlePhoneChange(phone, 'phone1')} 
        inputStyle={{ width: '100%' }}
        required
      />
    </Grid>
    
    <Grid item xs={6}>
      <PhoneInput 
          country={(userAllDetail?.country || "us").toLowerCase()} 
        value={formData.phone2}
        onChange={phone => handlePhoneChange(phone, 'phone2')}
        inputStyle={{ width: '100%' }}
      />
    </Grid>

          <Grid item xs={6}>
            <TextField
              label={t('email_label')}
              name="email1"
              type="email"
              variant="outlined"
              fullWidth
              required
              value={formData.email1}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label={t('email_2')}
              name="email2"
              type="email"
              variant="outlined"
              fullWidth
              value={formData.email2}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label={t('address')}
              name="addressline1"
              variant="outlined"
              fullWidth
              required
              value={formData.addressline1}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label={t('address_line_2')}
              name="addressline2"
              variant="outlined"
              fullWidth
              value={formData.addressline2}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={6}>
           
            <CountryDropdown
            value={formData.country}
            onChange={(val) => selectCountry(val)}
            style={{
              width: '100%',
              height: '56px',
              borderRadius: '5px',
              borderColor: '#ccc',
              padding: '10px',
            }}
          />
          </Grid>
          <Grid item xs={6}>
           
             <RegionDropdown
            country={formData.country}
            value={formData.state}
            label={t('state')}

            onChange={(val) => selectState(val)}
            style={{
              width: '100%',
              height: '56px',
              borderRadius: '5px',
              borderColor: '#ccc',
              padding: '10px',
            }}
          />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label={t('city')}
              name="city"
              variant="outlined"
              fullWidth
              required
              value={formData.city}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label={t('zip_code')}
              name="zipCode"
              variant="outlined"
              fullWidth
              required
              value={formData.zipCode}
              onChange={handleChange}
            />
          </Grid>
        
         
          
          <Grid item xs={6}>
            <TextField
              label={t('blood_group')}
              name="bloodType"
              variant="outlined"
              fullWidth
              required
              select
              value={formData.bloodType}
              onChange={handleChange}
            >
              <MenuItem value="A+">{t('a_plus')}</MenuItem>
              <MenuItem value="A-">{t('a_minus')}</MenuItem>
              <MenuItem value="B+">{t('b_plus')}</MenuItem>
              <MenuItem value="B-">{t('b_minus')}</MenuItem>
              <MenuItem value="O+">{t('o_plus')}</MenuItem>
              <MenuItem value="O-">{t('o_minus')}</MenuItem>
              <MenuItem value="AB+">{t('ab_plus')}</MenuItem>
              <MenuItem value="AB-">{t('ab_minus')}</MenuItem>
            </TextField>
          </Grid>
          <Grid item xs={6}>
            <TextField
              label={t('dob')}
              name="birthDate"
              type="date"
              variant="outlined"
              fullWidth
              required
              InputLabelProps={{ shrink: true }}
              inputProps={{ max: new Date().toISOString().split("T")[0] }} 
              value={formData.birthDate}
              onChange={handleChange}
              sx={{
  "& input": {
    height: "56px",     
    padding: "0 14px",
    lineHeight: "56px !important",
  }
}}

            />
          </Grid>
        
        
        </Grid>
        <Grid item xs={12} mt={2}>

          <Button
          className="w-100 mt-3 bg-white border border-primary text-primary d-flex align-items-center justify-content-center gap-1 py-2 mb-1"
          fullWidth
            variant="contained"
            component="label"
          >
            {t('upload_profile_photo')}
            <input
              type="file"
              accept="image/*"
              hidden
              onChange={handleFileChange}
            />
          </Button>
          {formData.profilePhoto && (
            <span>{formData.profilePhoto.name}</span>
          )}
        </Grid>
        <Box display="flex" justifyContent="flex-end" mt={2}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSubmit}
          >
              {contactLoading ? "Saving..." : "Save"}
          </Button>
        </Box>
      </Box>
    );
  };
  const [user, setUser] = useState([]);
  const [expandedUserId, setExpandedUserId] = useState(null);
  const [expandedUserDetails, setExpandedUserDetails] = useState(null);
  const [openConfirmDialogCategory, setOpenConfirmDialogCategory] = useState(false);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [openConfirmDialogCondition, setOpenConfirmDialogCondition] = useState(false);
  const [deleteUserIdCondition, setDeleteUserIdCondition] = useState(null);
  const [deleteUserId, setDeleteUserId] = useState(null);
  const [deleteUserIdCategory, setDeleteUserIdCategory] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const handleEdit = () => {
    setIsEditing(true);
  };



  const handleDelete = async () => {
    const token = getToken();
    try {
      await axios.delete(
        `${process.env.REACT_APP_URL}/api/userprofile/${deleteUserId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setExpandedUserId(null);
      setExpandedUserDetails(null);
      handleGetAllUsers();
    } catch (error) {
      console.log("Failed Deleting User Profile", error);
    } finally {
      setOpenConfirmDialog(false);
      setDeleteUserId(null);
    }
  };
  const handleDeleteCategory = async () => {
    const token = getToken();
    try {
      await axios.delete(
        `${process.env.REACT_APP_URL}/api/category/${deleteUserIdCategory}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      handleGetAllCategory();
      toast.success("Category Deleted Successfully")
    } catch (error) {
      console.log("Failed Deleting Category", error);
    } finally {
      setOpenConfirmDialogCategory(false);
      setDeleteUserIdCategory("");
    }
  };

  const handleDeleteCondition = async () => {
    const token = getToken();
    try {
      await axios.delete(
        `${process.env.REACT_APP_URL}/api/condition/${deleteUserIdCondition}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      handleGetAllConditions();
      toast.success("Condition Deleted Successfully")
    } catch (error) {
      console.log("Failed Deleting Condition", error);
    } finally {
      setOpenConfirmDialogCondition(false);
      setDeleteUserIdCondition("");
    }
  };

  const handleOpenConfirmDialog = (userId) => {
    setDeleteUserId(userId);
    setOpenConfirmDialog(true);
  };
  const handleOpenConfirmDialogCategory = (userId) => {
    setDeleteUserIdCategory(userId);
    setOpenConfirmDialogCategory(true);
  };
  const handleOpenConfirmDialogCondition = (userId) => {
    setDeleteUserIdCondition(userId);
    setOpenConfirmDialogCondition(true);
  };

  const handleCloseConfirmDialog = () => {
    setOpenConfirmDialogCategory(false);
    setOpenConfirmDialog(false);
    setDeleteUserId("");
    setOpenConfirmDialogCondition(false);
    setDeleteUserIdCondition("");
    setDeleteUserIdCategory("");
  };


  useEffect(()=>{
    handleGetAllUsers();
  },[]);
  const handleGetAllUsers = async () => {
    try {
      const token = getToken();
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/userprofile/all`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setUser(response?.data?.data);
    } catch (error) {
      console.log("Failed Fetching User Profiles", error);
    }
  };
  const renderContactList = (user, userAllDetail) => {
    const containerStyle = {
      // padding: '20px',
      paddingTop:"10px",
      maxWidth: '600px',
      margin: 'auto',
      fontFamily: 'Arial, sans-serif',
      borderRadius: '12px',
      // boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    };
  
    const listItemStyle = {
      marginBottom: '20px',
      padding: '15px',
      borderRadius: '8px',
      backgroundColor: '#f9f9f9',
      boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
    };
  
    const detailStyle = {
      marginBottom: '5px',
    };

    const buttonStyle = {
      background: 'none',
      border: 'none',
      color: '#007bff',
      cursor: 'pointer',
      textAlign: 'center',
      display: 'block',
      margin: '0px auto',
    };
    
    const moreDetailsStyle = {
      background: '#f9f9f9',
      padding: '10px',
      marginTop: '10px',
    };

    
    const handleShowMore = async (userId) => {
      setIsEditing(false)
      if (expandedUserId === userId) {
        setExpandedUserId(null);
        setExpandedUserDetails(null);
      } else {
        const token = getToken();
        try {
          const response = await axios.get(
            `${process.env.REACT_APP_URL}/api/userprofile/${userId}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          setExpandedUserId(userId);
          setExpandedUserDetails(response?.data?.data?.userProfileData);
          const userProfileData = response?.data?.data?.userProfileData;

          setFormData( {
            name: userProfileData?.name,
            phone1: userProfileData?.phone1,
            phone2: userProfileData?.phone2,
            email1: userProfileData?.email1,
            email2: userProfileData?.email2,
            addressline1: userProfileData?.address?.addressline1,
            addressline2: userProfileData?.address?.addressline2,
            city: userProfileData?.address?.city,
            state: userProfileData?.address?.state,
            zipCode: userProfileData?.address?.zipCode,
            country: userProfileData?.country,
            bloodType: userProfileData?.bloodType,
            birthDate: userProfileData?.birthDate ? formatDate(userProfileData?.birthDate) : "",
          });
        } catch (error) {
          console.log("Failed Fetching User Profile Details", error);
        }
      }
    };

    const formatDate = (dateString) => {
      const date = new Date(dateString);
      return date.toISOString().split('T')[0]; 
    };

  
    const handlePhoneChangeEdit = (phone, field) => {
      setFormData({ ...formData, [field]: phone });
    };

    const selectCountryEdit = (val) => {
      setFormData({ ...formData, country: val, state: '' });
    };
  
    const selectStateEdit = (val) => {
      setFormData((prevState) => ({
        ...prevState,
        state: val,
      }));
    };

  
    return (
      <div style={containerStyle}>
      <ul style={{ listStyleType: 'none', padding: 0 }}>
      {user.length === 0 ? (
  <p>{t('no_user_profile')}</p>
) : (user?.map((data, index) => (
          <li style={listItemStyle} key={index}>
           
            <p style={detailStyle}>{t('name_label')}: {data?.name}</p>
            <p style={detailStyle}>{t('phone_label')}: {data?.phone1 || "N/A"}</p>
            <p style={detailStyle}>{t('email_label')}: {data?.email1}</p>
            {expandedUserId === data._id && (
              <>
              <div>
                   <>
    {/* {data?.phone1 && (
      <p style={detailStyle}>{t('phone_label')}: {data.phone1 || "N/A"}</p>
    )} */}
    {/* {data?.email1 && (
      <p style={detailStyle}>{t('email_label')}: {data.email1}</p>
    )} */}
    {expandedUserDetails?.address && (
      <p style={detailStyle}>
        {t('address')}: {expandedUserDetails.address.addressline1} {expandedUserDetails.address.addressline2 && `, ${expandedUserDetails.address.addressline2}`} , {expandedUserDetails.address.city}, {expandedUserDetails.address.state}, {expandedUserDetails.address.zipCode}
      </p>
    )}
<p style={detailStyle}>{t('country')}: {expandedUserDetails?.country || "N/A"}</p>
    {expandedUserDetails?.birthDate && (<p style={detailStyle}>{t('dob')}: {new Date(expandedUserDetails?.birthDate).toLocaleDateString()}</p>)}
<p style={detailStyle}>{t('blood_group')}: {expandedUserDetails?.bloodType || "N/A"}</p>
  </>
                    {/* Display other user details here */}
                    {isEditing ? (<></>) : ( <div style={{display:"felx", justifyContent:"flex-end", textAlign:"right"}}>
                    <Button variant="contained" color="primary" 
                    style={{width:"100px", marginRight:"10px"}} 
                    onClick={handleEdit}
                    >
                      {t('edit')}
                    </Button>
                    <Button variant="contained" color="secondary" style={{width:"100px", background:"red"}} onClick={() => handleOpenConfirmDialog(data._id)}>
                      {t('delete')}
                    </Button>
                    </div>)}
                   
                  </div>
                {isEditing && (
                  <Box component="form" style={{ marginTop: "20px" }}>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <TextField
                          label={t('name_label')}
                          name="name"
                          variant="outlined"
                          fullWidth
                          required
                          value={formData.name || ''}
                          onChange={handleChangeEdit}
                        />
                      </Grid>
                      <Grid item xs={6}>
                      <PhoneInput
          country={(userAllDetail?.country || "us").toLowerCase()} 
        value={formData.phone1}
        onChange={phone => handlePhoneChangeEdit(phone, 'phone1')} 
        inputStyle={{ width: '100%' }}
        required
      />        
                      </Grid>
                      <Grid item xs={6}>
                       <PhoneInput
          country={(userAllDetail?.country || "us").toLowerCase()} 
        value={formData.phone2}
        onChange={phone => handlePhoneChangeEdit(phone, 'phone2')} 
        inputStyle={{ width: '100%' }}
      /> 
                      </Grid>
                      <Grid item xs={6}>
                        <TextField
                          label={t('email_label')}
                          name="email1"
                          type="email"
                          variant="outlined"
                          fullWidth
                          required
                          value={formData.email1 || ''}
                          onChange={handleChangeEdit}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <TextField
                          label={t('email_2')}
                          name="email2"
                          type="email"
                          variant="outlined"
                          fullWidth
                          value={formData.email2 || ''}
                          onChange={handleChangeEdit}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          label={t('address')}
                          name="addressline1"
                          variant="outlined"
                          fullWidth
                          required
                          value={formData.addressline1 || ''}
                          onChange={handleChangeEdit}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          label={t('address_line_2')}
                          name="addressline2"
                          variant="outlined"
                          fullWidth
                          value={formData.addressline2 || ''}
                          onChange={handleChangeEdit}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        {/* <TextField
                          label="Country"
                          name="country"
                          variant="outlined"
                          fullWidth
                          required
                          value={formData.country || ''}
                          onChange={handleChangeEdit}
                        /> */}
                         <CountryDropdown
            value={formData.country}
            onChange={(val) => selectCountryEdit(val)}
            style={{
              width: '100%',
              height: '56px',
              borderRadius: '5px',
              borderColor: '#ccc',
              padding: '10px',
            }}
          />
                      </Grid>
                      <Grid item xs={6}>
                        {/* <TextField
                          label="State"
                          name="state"
                          variant="outlined"
                          fullWidth
                          required
                          value={formData.state || ''}
                          onChange={handleChangeEdit}
                        /> */}
                         <RegionDropdown
            country={formData.country}
            value={formData.state}
            label={t('state')}

            onChange={(val) => selectStateEdit(val)}
            style={{
              width: '100%',
              height: '56px',
              borderRadius: '5px',
              borderColor: '#ccc',
              padding: '10px',
            }}
          />
                      </Grid>
                     
                      <Grid item xs={6}>
                        <TextField
                          label={t('city')}
                          name="city"
                          variant="outlined"
                          fullWidth
                          required
                          value={formData.city || ''}
                          onChange={handleChangeEdit}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <TextField
                          label={t('zip_code')}
                          name="zipCode"
                          variant="outlined"
                          fullWidth
                          required
                          value={formData.zipCode || ''}
                          onChange={handleChangeEdit}
                        />
                      </Grid>
                    
                      <Grid item xs={6}>
                        <TextField
                          label={t('blood_group')}
                          name="bloodType"
                          variant="outlined"
                          fullWidth
                          required
                          select
                          value={formData.bloodType || ''}
                          onChange={handleChangeEdit}
                        >
                          <MenuItem value="A+">{t('a_plus')}</MenuItem>
                          <MenuItem value="A-">{t('a_minus')}</MenuItem>
                          <MenuItem value="B+">{t('b_plus')}</MenuItem>
                          <MenuItem value="B-">{t('b_minus')}</MenuItem>
                          <MenuItem value="O+">{t('o_plus')}</MenuItem>
                          <MenuItem value="O-">{t('o_minus')}</MenuItem>
                          <MenuItem value="AB+">{t('ab_plus')}</MenuItem>
                          <MenuItem value="AB-">{t('ab_minus')}</MenuItem>
                        </TextField>
                      </Grid>
                      <Grid item xs={6}>
                        <TextField
                          label={t('dob')}
                          name="birthDate"
                          type="date"
                          variant="outlined"
                          fullWidth
                          InputLabelProps={{ shrink: true }}
                          value={formData.birthDate || ''}
                          onChange={handleChangeEdit}
                                        sx={{
  "& input": {
    height: "56px",     
    padding: "0 14px",
    lineHeight: "56px !important",
  }
}}
                        />
                      </Grid>
                      
                      <Grid item xs={12}>
                      <div style={{display:"felx", justifyContent:"flex-end", textAlign:"right"}}>

                        <Button variant="contained" color="primary" onClick={handleSubmitUpdate} style={{marginRight:"10px"}}>
                           {contactLoading ? "Saving..." : "Save"}
                        </Button>
                        <Button variant="contained" color="primary" 
                        onClick={() => setIsEditing(false)}
                        >
                          {t('cancel')}
                        </Button>
                        </div>
                      </Grid>
                    </Grid>
                  </Box>
                )}
              </>
            )}
            <div style={{justifyContent:"center", textAlign:"center"}}>
            <Button onClick={() => handleShowMore(data._id)}>
            {expandedUserId === data._id 
                ? <>
                     {t('show_less')} <AiOutlineUp style={{ marginLeft: '8px' }} />
                  </> 
                : <>
                    {t('show_more')} <AiOutlineDown style={{ marginLeft: '8px' }} />
                  </>}    
                          </Button>
                  </div>
          </li>
  ))
)}      </ul>
    </div>
  );
};

  // Add Category
  const [itemName, setItemName] = useState(null);
  const [itemDescription, setItemDescription] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const dataToSent = {
        categoryName: itemName,
        categoryDescription: itemDescription,
      };
      const token = getToken();
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/api/category`,
        dataToSent,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      toast.success(response?.data?.message);
      handleGetAllCategory();
      setItemName("");
      setItemDescription("");
      setIsAddingCategory(false);
      setSelectedTab2(1)
    } catch (error) {
      toast.error(error?.response?.data?.message);
    }
  };

  // Add Condition
  const [conditionName, setConditionName] = useState("");
  const [description, setDescription] = useState(null);
  const [categoryIdForCondition, setCategoryIdForCondition] = useState(null);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [photos, setPhotos] = useState([]);

  const MAX_IMAGES = 4;

  const splitFileLink = (a) => {
    const x = a.split("_");
    const y = x[x.length - 1];
    return decodeURIComponent(y);
  };

  const handleFileInputChangeEdit = (e) => {
    const newFiles = Array.from(e.target.files); // Convert FileList to array
  
    // Append new files to the existing ones
    setUploadedFiles((prevFiles) => [...prevFiles, ...newFiles]);
  
  };
  
  const handleFileInputChange = async (event) => {
    const chosenFiles = Array.prototype.slice.call(event.target.files);
    const uploaded = [...photos];
    if (chosenFiles?.length > MAX_IMAGES) {
      toast.error(`You can only upload up to ${MAX_IMAGES} images.`);
      return;
    }
    chosenFiles.some((file) => {
      if (file?.size > 2097152) {
        toast.error("Entity is too large");
        return;
      }
      uploaded.push(file);
    });
    setPhotos(uploaded);
    try {
      const formData = new FormData();
      uploaded.forEach((file) => {
        formData.append("files", file);
      });
      const token = getToken();
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/api/file/upload/multiple`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      toast.success(response?.data?.message);
      setUploadedFiles(response?.data?.data);
    } catch (error) {
      toast.error(error?.response?.data?.message);
    }
  };

  const handleConditionAdd = async (e) => {
    e.preventDefault();
    if (!categoryIdForCondition) {
      toast.error("No Category Selected!");
      return;
    }

    try {
      const dataToSent = {
        conditionName: conditionName,
        conditionDescription: description,
        conditionDocuments: uploadedFiles,
        categoryId: categoryIdForCondition,
      };
      const token = getToken();
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/api/condition`,
        dataToSent,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      toast.success(response?.data?.message);
      // setConditionId(response?.data?.__id)
      // setMark(null);
      handleGetAllConditions();
      setConditionName("");
      setDescription("");
      setFile("");
      setIsAddingCondition(false);
    } catch (error) {
      toast.error(error?.response?.data?.message);
    }
  };

  // Add contact
  const [emergencyContact, setEmergencyContact] = useState(null);
  const [contactDetailsShow, setContactDetailsShow] = useState(null);
  const [emergencyContactDetails, setEmergencyContactDetails] = useState(null);
  const [emergencyContactId, setEmergencyContactId] = useState(null);
  const [deleteId, setDeleteId] = useState(null);
  
  const [editId, setEditId] = useState(null);
  const [editData, setEditData] = useState({});
  const handleEditClick = (contact) => {
    setEditId(contact._id);
    setEditData({
      firstName: contact.firstName,
      lastName: contact.lastName,
      email: contact.email,
      mobile: contact.mobile,
      relationShip: contact.relationShip,
    });
  };

  const handleCancelClick = () => {
    setEditId(null);
  };

  const handleSaveClick = () => {
    // Save the edited data
    // Call your API or update your state here

    setEditId(null);
  };

  const handleGetAllContacts = async () => {
    try {
      const token = getToken();
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/emergencyContact/all`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setEmergencyContact(response?.data?.data);
    } catch (error) {
      console.log("Failed Fetching emergencyContact", error);
    }
  };
  const handleGetSingleContact = async () => {
    setEmergencyContactDetails("");
    try {
      const token = getToken();
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/emergencyContact/${emergencyContactId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setEmergencyContactDetails(response?.data?.data);
    } catch (error) {
      console.log("Failed Fetching emergencyContact", error);
    }
  };
  useEffect(() => {
    handleGetSingleContact();
  }, [emergencyContactId]);

  const [contactPerson, setContactPerson] = useState({
    firstName: "",
    lastName: "",
    email: "",
    // mobileCode: "+91",
    mobile: "",
    relationShip: "",
    conditionId: "",
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const val = type === "checkbox" ? checked : value;
    setContactPerson((prevState) => ({
      ...prevState,
      [name]: val,
    }));
  };
  const handleContactAdd = async (e) => {
    e.preventDefault();
      setContactLoading(true);

  if (contactPerson.email && !(await validateEmail(contactPerson.email))) {
    toast.error("Invalid email address.");
    setContactLoading(false);
    return;
  }

  if (contactPerson.mobile && !(await validatePhoneNumber(contactPerson.mobile))) {
    toast.error("Invalid phone number.");
    setContactLoading(false);
    return;
  }
    try {
      const dataToSent = contactPerson;
      const token = getToken();
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/api/emergencyContact`,
        dataToSent,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      toast.success(response?.data?.message);
      // setContactModal(null);
      handleGetAllContacts();
      setContactPerson({
        firstName: "",
        lastName: "",
        email: "",
        mobileCode: "",
        mobile: "",
        relationShip: "",
        conditionId: "",
      });
      // setIsAddingContact(false);
    } catch (error) {
      toast.error(error?.response?.data?.message);
    } finally{
          setContactLoading(false);

    }
  };
  const [showDelete, setShowDelete] = useState(false);
  const handleCloseDelete = () => setShowDelete(false);
  const handleShowDelete = (contactid) => {
    setDeleteId(contactid);
    setShowDelete(true);
  };

  const handleDeletePost = async () => {
    if (!deleteId) {
      toast.error("Please try later");
    }
    try {
      const token = getToken();
      const response = await axios.delete(
        `${process.env.REACT_APP_URL}/api/emergencyContact/${deleteId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      handleGetAllContacts();
      setDeleteId("");
      handleCloseDelete();
      toast.success("Contact deleted successfully");
    } catch (error) {
      console.error("Failed ", error);
      toast.error(error?.response?.data?.message || "Failed to delete Contact");
    }
  };
  const [profile, setProfile] = useState(false);
  const [profileContact, setProfileContact] = useState(false);
  const [profileContact1, setProfileContact1] = useState(false);

  const [dropdown, setDropdown] = useState();

  const handleDropdown = async () => {
    try {
      const token = getToken();
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/default-setting/values?getFeild=relationships`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setDropdown(response.data.data.defaultData.relationships);
    } catch (error) {
      console.error("Failed Fetching dropdown", error);
    }
  };
useEffect(()=>{
  handleDropdown();
},[]);

// Edit category 
const [editingCategoryId, setEditingCategoryId] = useState(null);

const handleEditCategory = (category) => {
  setEditingCategoryId(category._id); 
  setItemName(category.categoryName); 
  setItemDescription(category.categoryDescription); 
};

// Function to handle cancel edit
const handleCancelEdit = () => {
  setEditingCategoryId(null);  
  setItemName('');
  setItemDescription('');
};

const handleUpdateCategory = async (e) => {
  e.preventDefault();
  try {
    const dataToSent = {
      categoryName: itemName,
      categoryDescription: itemDescription,
    };
    const token = getToken();
    const response = await axios.put(
      `${process.env.REACT_APP_URL}/api/category/${editingCategoryId}`,
      dataToSent,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    toast.success(response?.data?.message);
    handleGetAllCategory();
    setItemName("");
    setItemDescription("");
    setEditingCategoryId("");
    // setIsAddingCategory(false);
  } catch (error) {
    toast.error(error?.response?.data?.message);
  }
};

// Condition 
const [editingConditionId, setEditingConditionId] = useState("");

const handleEditCondition = (condition) => {
  // Set the state for editing
  setEditingConditionId(condition._id); 

  setConditionName(condition.conditionName);

  setDescription(condition.conditionDescription);

  setSelectedCategory(condition?.categoryId?._id);

  setUploadedFiles(condition.conditionDocuments || []);
};


// Function to handle cancel
const handleCancelEditCondition = () => {
  setEditingConditionId(""); 
  setConditionName('');
  setDescription('');
  setSelectedCategory('');
  setUploadedFiles([]);
};


const handleConditionUpdate = async (e) => {
  e.preventDefault();
  if (!categoryIdForCondition) {
    toast.error("No Category Selected!");
    return;
  }

  try {
    const dataToSent = {
      conditionName: conditionName,
      conditionDescription: description,
      conditionDocuments: uploadedFiles,
      categoryId: categoryIdForCondition,
    };
    const token = getToken();
    const response = await axios.put(
      `${process.env.REACT_APP_URL}/api/condition/${editingConditionId}`,
      dataToSent,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    toast.success(response?.data?.message);
    handleGetAllConditions();
    setConditionName("");
    setDescription("");
    setFile("");
    setUploadedFiles([]);
    handleCancelEditCondition();
    // setIsAddingCondition(false);
  } catch (error) {
    toast.error(error?.response?.data?.message);
  }
};

// const [profile, setProfile] = useState(false);
const [connections, setConnections] = useState([]);
const [selectedConnection, setSelectedConnection] = useState("");
const [selectedConnectionContact, setSelectedConnectionContact] = useState("");
const [allData, setAllData] = useState([]);

const handleAllTerms = async() => {
  try {
      const token = getToken();
    const response = await axios.get(`${process.env.REACT_APP_URL}/api/terms-and-condition/content`, {
      headers: {
        "Authorization": `Bearer ${token}`
              }
    });
    const criticalDTerms = response.data.data.find(item => item.platform === "critical-D");
    if(criticalDTerms){
      setAllData(criticalDTerms);
    }
  } catch (error) {
    console.error("Failed Fetching ", error);
  }
}
useEffect(()=>{
  handleAllTerms();
},[]);

const handleConnections = async () => {
  try {
    const token = getToken();
    const response = await axios.get(
      `${process.env.REACT_APP_URL}/api/connection/all`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      }
    );
    setConnections(response.data.data.connectionList);
  } catch (error) {
    console.log("Failed Fetching Connections", error);
  }
};

useEffect(() => {
  handleConnections();
}, []);

const handleImportProfile = async () => {
  try {
    const token = getToken();
    const response = await axios.post(
      `${process.env.REACT_APP_URL}/api/userprofile/import`,
      { connectionIds: [selectedConnection] },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    handleGetAllUsers();
    const info = response.data.data[0];

    setFormData({
      name: info?.name || '',
      phone1: info?.phone1 || '',
      email1: info?.email1 || '',
      profilePhoto: info?.profilePhotoLink || '',
    })
    setSelectedTab(0);

  } catch (error) {
    console.log("Failed to Import Profile", error);
  }
};
const handleImportProfileContact = async () => {
  try {
    const token = getToken();
    const response = await axios.post(
      `${process.env.REACT_APP_URL}/api/emergencyContact/import`,
      { connectionIds: [selectedConnectionContact] },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    const info = response.data.data[0];
    handleGetAllContacts();
    setContactPerson({
      firstName: info?.firstName || '',
      lastName: info?.lastName || '',
      email: info?.email || '',
    })
    setSelectedTab1(0);

  } catch (error) {
    console.log("Failed to Import Profile", error);
  }
};

const handlePhoneChangeContact = (phone, field) => {
  setContactPerson({ ...contactPerson, [field]: phone });
};
const [loading, setLoading] = useState(true); 
const [acceptedLoader, setAcceptedLoader] =useState(true);
const handleTermsCondition = async () => {
  try {
      const token = getToken();
      const response = await axios.get(
          `${process.env.REACT_APP_URL}/api/terms-and-condition/critical-D`, {
          headers: {
              "Authorization": `Bearer ${token}`,
          }
      }
      )
        // handleNext();
        const hasAgreed = response?.data?.data?.data?.agreeToCriticalDTermsAndConition;
  
        if (hasAgreed) {
            setStep(2);
        } else {
            setStep(1); 
        }
  } catch (error) {
      console.log("Failed Fetching T&C", error);
  } finally{
    setLoading(false);
    setAcceptedLoader(false);
  }
}


useEffect(()=>{
handleTermsCondition();
},[]);

const handleAcceptTermsCondition = async () => {
  try {
      const token = getToken();
      const response = await axios.put(
          `${process.env.REACT_APP_URL}/api/terms-and-condition/critical-D`,
          {
            CriticalD: {
              agreeToCriticalDTermsAndConition: true,
            }
          }, {
          headers: {
              "Authorization": `Bearer ${token}`,
          }
      }
      )
        setStep(2); 
  } catch (error) {
      console.log("Failed Fetching T&C", error);
  }
}

if (loading) {
  return <div>{t('query_loading')}</div>; 
}


  return (<>
<Toaster position="top-right" reverseOrder={false}/>
 {contactLoading && (
        <div style={styles.loaderOverlay}>
          <CircularProgress style={{ color: "white" }} />
        </div>
      )}
<div className="">
      <Modal
        size="md"
        className="fade"
        id="post-modal"
        onHide={handleCloseDelete}
        show={showDelete}
        centered
        style={{ marginTop: "100px", maxHeight: "80vh" }}
      >
        <Modal.Header className="d-flex justify-content-between">
          <Modal.Title id="post-modalLabel">{t('delete_post')}</Modal.Title>
          <Link to="#" className="lh-1" onClick={handleCloseDelete}>
            <span className="material-symbols-outlined">close</span>
          </Link>
        </Modal.Header>
        <Modal.Body>
          <div
            className="d-flex align-items-center"
            style={{ fontSize: "16px" }}
          >
            <p>
              {t('delete_contact_confirmation')}
            </p>
          </div>
          <button
            type="submit"
            className="btn btn-primary d-block w-100 mt-0"
            onClick={handleDeletePost}
          >
            {t('delete')}       </button>
        </Modal.Body>
      </Modal>
      {acceptedLoader ? (
        <div>{t('query_loading')}</div>
      ):(
      <div className="stepper">
     
      {step !== 1 && (
        <div className="stepper-menu" style={{ display: 'flex'}}>
        <Button className={step === 2 ? 'active' : ''} onClick={() => setStep(2)} style={{borderTopLeftRadius:"5px", borderBottomLeftRadius:"5px"}}>{t('user_profile')}</Button>
        <Button className={step === 3 ? 'active' : ''} onClick={() => setStep(3)}>{t('emergency_contact')}</Button>
        <Button className={step === 4 ? 'active' : ''} onClick={() => setStep(4)}>{t('categories')} / {t('conditions')}</Button>
        <Button className={step === 5 ? 'active' : ''} onClick={() => setStep(5)} style={{borderEndEndRadius:"5px", borderTopRightRadius:"5px"}}>{t('communication_channel')}</Button>
      </div>
      )}
        <div className="step-header">{/* <h3>Step {step} of 9</h3> */}</div>

        {step === 1 && (
          <div className="terms-conditions">
            <h2 style={{ width:"100%", textAlign:"center"}}>{t('terms_and_conditions_header')}</h2>
            <p style={{ fontSize: "14px" }} dangerouslySetInnerHTML={{__html: allData.content}}>
            </p>
            {/* <ul style={{ fontSize: "14px" }}>
              <li>
                Term 1: Lorem ipsum dolor sit amet, consectetur adipiscing elit.
              </li>
              <li>
                Term 2: Sed do eiusmod tempor incididunt ut labore et dolore
                magna aliqua.
              </li>
              <li>
                Term 3: Ut enim ad minim veniam, quis nostrud exercitation
                ullamco laboris.
              </li>
              <li>
                Term 4: Duis aute irure dolor in reprehenderit in voluptate
                velit esse cillum.
              </li>
              <li>
                Term 5: Excepteur sint occaecat cupidatat non proident, sunt in
                culpa qui officia.
              </li>
            </ul> */}
            <label
              style={{
                fontSize: "14px",
                alignItems: "center",
                display: "flex",
              }}
            >
              <input
                style={{ marginRight: "10px" }}
                type="checkbox"
                checked={termsAccepted}
                onChange={handleTermsChange}
              />
              {t('accept_terms')}
            </label>
          </div>
        )}

        {step === 2 && (
         <Box className="user-profile-options">
         <Typography variant="h6">{t('user_profile')}</Typography>
         <Tabs
           value={selectedTab}
           onChange={handleTabChange}
           variant="scrollable"
           scrollButtons="auto"
           allowScrollButtonsMobile
         >
           <Tab label={t('user_list')} style={{ fontSize: "12px" }} />
           <Tab label={t('import_profile')} style={{ fontSize: "12px" }} />
           <Tab label={t('import_contact')} style={{ fontSize: "12px" }} />
           <Tab label={t('create_user')} style={{ fontSize: "12px" }} />
         </Tabs>
       
         <Box>
         {selectedTab === 0 && renderContactList(user, userAllDetail)}
           {selectedTab === 1 && (
             <>
             {profile ? (
               <Box>
               <h5 style={{marginTop:"10px"}}>{t('select_connection')}</h5>
               {connections.length === 0 ? (
                 <Typography variant="body1" color="textSecondary">
                   {t('no_connections')}.
                 </Typography>
               ) : (
                 <>
                   <RadioGroup
                     value={selectedConnection}
                     onChange={(e) => setSelectedConnection(e.target.value)}
                   >
                     <List>
                       {connections.map((connection) => {
                         const connectionDetails = connection.userId || connection.connectionUserId;
                         if (!connectionDetails) return null;
             
                         return (
                           <ListItem key={connection._id} button>
                             <FormControlLabel
                               value={connection._id}
                               control={<Radio />}
                               label={
                                 <Box display="flex" alignItems="center">
                                   <Avatar 
                                     src={connectionDetails.profileImageLink ? connectionDetails.profileImageLink : '/profile.png'} 
                                     alt={`${connectionDetails.firstName} ${connectionDetails.lastName}`} 
                                     sx={{ marginRight: 2 }} 
                                   />
                                   <ListItemText
                                     primary={`${connectionDetails.firstName} ${connectionDetails.lastName}`}
                                    //  secondary={connectionDetails._id}
                                   />
                                 </Box>
                               }
                             />
                           </ListItem>
                         );
                       })}
                     </List>
                   </RadioGroup>
                   <Button
                     variant="contained"
                     color="primary"
                     style={{marginInline:"auto", display:"flex", justifyContent:"center", background:"#50B5FF", color:"#fff"}}
                     onClick={handleImportProfile}
                     disabled={!selectedConnection}
                   >
                     {t('import_selected_profile')}
                   </Button>
                 </>
               )}
             </Box>
             
             ) : (
               <Box
                 sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px' }}
               >
                 <Button variant="contained" onClick={() => setProfile(true)}>
                   {t('import')} {projectName} {t('profile')}
                 </Button>
               </Box>
             )}
           </>
       
           )}
           {selectedTab === 2 && (<>
          { profileContact ? (
<div> {renderDummyDetails()}</div>
          ) : (
<Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px' }}>
               <Button variant="contained" disabled
              //  onClick={()=>setProfileContact(true)}
               >{t('import_from_phonebook')} </Button>
             </Box>
          )}
             
             </>
           )}
           {selectedTab === 3 && renderCreateContactForm(userAllDetail)}
         </Box>
       </Box>
       
        )}
        

        {step === 3 && (
          <Box>
            <Tabs
              value={selectedTab1}
              onChange={handleTabChange1}
              variant="scrollable"
              scrollButtons="auto"
              allowScrollButtonsMobile
              style={{ marginBottom: "10px" }}
            >
             <Tab label={t('contact_list')} style={{ fontSize: "12px" }} />
<Tab label={`${t('import_from')} Dirido`} style={{ fontSize: "12px" }} />
<Tab label={t('add_contact')} style={{ fontSize: "12px" }} />

            </Tabs>

            <Box>
            {selectedTab1 === 0 && (
                <div>
                    <Box>
                      <div className="w-100 mt-3">
                        {emergencyContact?.length > 0 ? (
                          emergencyContact?.map((contact, index) => (
                            <div
                              className="d-flex flex-column justify-content-between align-items-center w-100 mt-3"
                              style={{
                                border: "1px solid #e2e2e2",
                                padding: "5px",
                                fontSize: "15px",
                                borderRadius: "5px",
                              }}
                              key={contact?._id}
                            >
                              <div className="d-flex justify-content-between align-items-center w-100">
                                <div className="d-flex align-items-center">
                                  <MdOutlinePhoneEnabled
                                    style={{
                                      fontSize: "20px",
                                      transform: "rotate(90deg)",
                                      marginRight: "10px",
                                    }}
                                  />
                                  {contact?.firstName} {contact?.lastName}
                                </div>
                                <div
                                  onClick={() => {
                                    setContactDetailsShow(
                                      contactDetailsShow === index
                                        ? null
                                        : index
                                    );
                                    setEmergencyContactId(contact?._id);
                                  }}
                                >
                                  {contactDetailsShow === index ? (
                                    <MdExpandLess size={28} />
                                  ) : (
                                    <MdExpandMore size={28} />
                                  )}
                                </div>
                              </div>
                              {index === contactDetailsShow && (
                                <div className="rounded w-100">
                                  {editId === contact?._id ? (
                                    <Box
                                      mt={2}
                                      p={2}
                                      style={{
                                        border: "1px solid #e2e2e2",
                                        borderRadius: "5px",
                                      }}
                                    >
                                      <Typography variant="h6">
                                        {t('edit_contact')}
                                      </Typography>
                                      <TextField
                                        label={t('first_name_label')}
                                        name="firstName"
                                        value={editData.firstName}
                                        onChange={handleChange}
                                        fullWidth
                                        sx={{ mb: 2 }}
                                      />
                                      <TextField
                                        label={t('last_name_label')}
                                        name="lastName"
                                        value={editData.lastName}
                                        onChange={handleChange}
                                        fullWidth
                                        sx={{ mb: 2 }}
                                      />
                                      <TextField
                                        label={t('email_label')}
                                        name="email"
                                        value={editData.email}
                                        onChange={handleChange}
                                        fullWidth
                                        sx={{ mb: 2 }}
                                      />
                                      <TextField
                                        label={t('phone_label')}
                                        type="tel"
                                        name="mobile"
                                        value={editData.mobile}
                                        onChange={(e) => {
                                          const re = /^[0-9\b]+$/;
                                          if (
                                            e.target.value === "" ||
                                            re.test(e.target.value)
                                          ) {
                                            setEditData((prevState) => ({
                                              ...prevState,
                                              mobile: e.target.value,
                                            }));
                                          }
                                        }}
                                        fullWidth
                                        sx={{ mb: 2 }}
                                      />
                                      <FormControl fullWidth sx={{ mb: 2 }}>
                                        <InputLabel>{t('relationship')}</InputLabel>
                                        <Select
                                          name="relationShip"
                                          value={editData.relationShip}
                                          onChange={handleChange}
                                          label={t('relationship')}
                                        >
                                          {dropdown?.map((data, index) => (
                                          <MenuItem key={index} value={data}>
                                            {data}
                                          </MenuItem>
                                          ))}
                                        </Select>
                                      </FormControl>
                                      <Box
                                        display="flex"
                                        justifyContent="flex-end"
                                        gap={2}
                                      >
                                        <Button
                                          variant="outlined"
                                          color="secondary"
                                          onClick={handleCancelClick}
                                        >
                                          {t('cancel')}
                                        </Button>
                                        <Button
                                          variant="contained"
                                          color="primary"
                                          onClick={handleSaveClick}
                                        >
                                           {t('save')}
                                        </Button>
                                      </Box>
                                    </Box>
                                  ) : (
                                    <div className="d-flex flex-column gap-2">
                                      <div className="d-flex gap-2">
                                        <div
                                          className="text-black text-nowrap"
                                          style={{ fontSize: "15px" }}
                                        >
                                          {t('email_label_address')}:
                                        </div>
                                        <div
                                          style={{
                                            textAlign: "start",
                                            wordBreak: "break-word",
                                          }}
                                        >
                                          {emergencyContactDetails?.email}
                                        </div>
                                      </div>
                                      <div className="d-flex gap-2">
                                        <div
                                          className="text-black text-nowrap"
                                          style={{ fontSize: "15px" }}
                                        >
                                          {t('contact_number')}:
                                        </div>
                                        <div
                                          style={{
                                            textAlign: "start",
                                            wordBreak: "break-word",
                                          }}
                                        >
                                          {emergencyContactDetails?.mobileCode}
                                          {emergencyContactDetails?.mobile}
                                        </div>
                                      </div>
                                      {emergencyContactDetails?.relationShip && (
                                      <div className="d-flex gap-2">
                                        <div
                                          className="text-black text-nowrap"
                                          style={{ fontSize: "15px" }}
                                        >
                                          {t('relationship')}:
                                        </div>
                                        <div
                                          style={{
                                            textAlign: "start",
                                            wordBreak: "break-word",
                                          }}
                                        >
                                          {
                                            emergencyContactDetails?.relationShip
                                          }
                                        </div>
                                      </div>)}
                                      <div
                                        className="d-flex gap-2"
                                        style={{ marginLeft: "auto" }}
                                      >
                                        {/* <Button
                        variant="outlined"
                        onClick={() => handleEditClick(contact)}
                        style={{ marginRight: '5px' }}
                      >
                        Edit
                      </Button> */}
                                        <Button
                                          style={{
                                            padding: "5px 10px",
                                            fontSize: "14px",
                                            backgroundColor: "#dc3545",
                                            color: "white",
                                            border: "none",
                                            borderRadius: "3px",
                                            cursor: "pointer",
                                          }}
                                          onClick={() =>
                                            handleShowDelete(
                                              emergencyContactDetails._id
                                            )
                                          }
                                        >
                                          {t('delete')}
                                        </Button>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              )}
                            </div>
                          ))
                        ) : (
                          <div>{t('no_emergency_contact')}</div>
                        )}
                      </div>
                    </Box>
                 
                </div>
              )}
              {selectedTab1 === 1 && (
                <>
                  {" "}
                  <Typography variant="h6" style={{ marginBottom: "10px" }}>
                    {t('emergency_contact')}
                  </Typography>
                  { profileContact1 ? (
   <Box>
   <h5 style={{marginTop:"10px"}}>{t('select_connection')}</h5>
   {connections.length === 0 ? (
     <Typography variant="body1" color="textSecondary">
       {t('no_connections')}
     </Typography>
   ) : (
     <>
       <RadioGroup
         value={selectedConnectionContact}
         onChange={(e) => setSelectedConnectionContact(e.target.value)}
       >
         <List>
           {connections?.map((connection) => {
             const connectionDetails = connection?.userId || connection?.connectionUserId;
             if (!connectionDetails) return null;
 
             return (
               <ListItem key={connection._id} button>
                 <FormControlLabel
                   value={connection._id}
                   control={<Radio />}
                   label={
                     <Box display="flex" alignItems="center">
                       <Avatar 
                         src={connectionDetails?.profileImageLink ? connectionDetails?.profileImageLink : '/profile.png'} 
                         alt={`${connectionDetails?.firstName} ${connectionDetails?.lastName}`} 
                         sx={{ marginRight: 2 }} 
                       />
                       <ListItemText
                         primary={`${connectionDetails?.firstName} ${connectionDetails?.lastName}`}
                        //  secondary={connectionDetails._id}
                       />
                     </Box>
                   }
                 />
               </ListItem>
             );
           })}
         </List>
       </RadioGroup>
       <Button
         variant="contained"
         color="primary"
         style={{marginInline:"auto", display:"flex", justifyContent:"center", background:"#50B5FF", color:"#fff"}}
         onClick={handleImportProfileContact}
         disabled={!selectedConnectionContact}
       >
         {t('import_selected_profile')}
       </Button>
     </>
   )}
 </Box>
          ) : (
<Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px' }}>
               <Button variant="contained" onClick={()=>setProfileContact1(true)}>{t('import_contact_from')} Dirido </Button>
             </Box>
          )}
                  {/* {renderDummyDetails()} */}
                </>
              )}
              {selectedTab1 === 2 && (
                <div>
                
                      <Box mt={2}>
                      <Typography variant="h6">{t('add_contact')}</Typography>
                      <TextField
                        label={t('first_name_label')}
                        name="firstName"
                        value={contactPerson.firstName}
                        onChange={handleChange}
                        fullWidth
                        required
                        sx={{ mb: 2 }}
                      />
                      <TextField
                        label={t('last_name_label')}
                        name="lastName"
                        value={contactPerson.lastName}
                        onChange={handleChange}
                        fullWidth
                        required
                        sx={{ mb: 2 }}
                      />
                      <TextField
                        label={t('email_label')}
                        name="email"
                        value={contactPerson.email}
                        onChange={handleChange}
                        fullWidth
                        required
                        sx={{ mb: 2 }}
                      />
                      <FormControl fullWidth sx={{ mb: 2 }}>
                        <InputLabel>{t('relationship')}*</InputLabel>
                        <Select
                          name="relationShip"
                          value={contactPerson.relationShip}
                          onChange={handleChange}
                          label={t('relationship')} 
                          required
                        >
                           {dropdown?.map((data, index) => (
                            <MenuItem key={index} value={data}>{data}</MenuItem>
                            ))}
                          {/* <MenuItem value="Mother">Mother</MenuItem>
                          <MenuItem value="Father">Father</MenuItem>
                          <MenuItem value="Sister">Sister</MenuItem>
                          <MenuItem value="Brother">Brother</MenuItem>
                          <MenuItem value="Friend">Friend</MenuItem>
                          <MenuItem value="Partner">Partner</MenuItem> */}
                        </Select>
                      </FormControl>
                         <PhoneInput
          country={(userAllDetail?.country || "us").toLowerCase()} 
        value={contactPerson.mobile}
        onChange={phone => handlePhoneChangeContact(phone, 'mobile')} 
        inputStyle={{ width: '100%', paddingBlock:"16px !important", marginBottom:"20px" }}
        required
      />
                      {/* <TextField
                        label="Phone Number"
                        type="tel"
                        maxLength={10}
                        value={contactPerson.mobile}
                        onChange={(e) => {
                          const re = /^[0-9\b]+$/;
                          if (
                            e.target.value === "" ||
                            re.test(e.target.value)
                          ) {
                            setContactPerson((prevState) => ({
                              ...prevState,
                              mobile: e.target.value,
                            }));
                          }
                        }}
                        fullWidth
                        sx={{ mb: 2 }}
                      /> */}
                      
                      <Box display="flex" justifyContent="flex-end" gap={2} mt={2}>
                        {/* <Button
                          variant="outlined"
                          color="secondary"
                          onClick={handleCancelAddContact}
                        >
                          Cancel
                        </Button> */}
                        <Button
                          variant="contained"
                          color="primary"

                          onClick={(e) => handleContactAdd(e)}
                        >
                        {contactLoading ? "Saving..." : "Save"}
                        </Button>
                      </Box>
                    </Box>
                </div>
              )}
            </Box>
          </Box>
        )}
         {step === 4 && (
          <Box className="user-profile-options">
            <Tabs
              value={selectedTab2}
              onChange={handleTabChange2}
              variant="scrollable"
              scrollButtons="auto"
              allowScrollButtonsMobile
            >
              <Tab label={t('categories')} style={{ fontSize: "12px" }} />
              <Tab label={t('conditions')} style={{ fontSize: "12px" }} />
            </Tabs>

            <Box>
              {selectedTab2 === 0 && (
                <Box className="" mt={2}>
            <Box className="category">
              {!isAddingCategory ? (
                <Box>
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <Typography variant="h6">{t('categories')}</Typography>
                    <Button
                      variant="contained"
                      color="primary"
                      style={{background:"#50B5FF"}}
                      onClick={handleAddCategory}
                    >
                      {t('add_category')}
                    </Button>
                  </Box>

                  {categoryAll?.length > 0 ? (
                  <Box
                  mt={2}
                  style={{ overflowY: "auto", maxHeight: "50vh" }}
                >
                  <div>
    {categoryAll?.map((category, index) => (
      <Box
        key={index}
        mb={2}
        p={2}
        border={1}
        borderColor="grey.300"
        display="flex"
        flexDirection="column"
      >
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Box>
            <Typography variant="body1">
              <strong>{t('name_label')}:</strong> {category?.categoryName}
            </Typography>
            <Typography variant="body2">
              <strong>{t('description')}:</strong> {category?.categoryDescription}
            </Typography>
          </Box>
          <Box>
            <EditIcon 
              style={{ cursor: 'pointer', marginRight: '10px', color: "#50B5FF" }} 
              onClick={() => handleEditCategory(category)} 
            />
            <DeleteIcon 
              style={{ cursor: 'pointer', color: "red" }} 
              onClick={() => handleOpenConfirmDialogCategory(category._id)} 
            />
          </Box>
        </Box>

        {/* Conditional rendering of the update form */}
        {editingCategoryId === category._id && (
          <Box mt={2}>
            <Typography variant="h6" sx={{mb: 2}}>{t('update_category')}</Typography>
            <TextField
              label={t('category_name')}
              value={itemName}
              onChange={(e) => setItemName(e.target.value)}
              fullWidth
              sx={{ mb: 2}}
            />
            <TextField
              label={t('category_description')}
              value={itemDescription}
              onChange={(e) => setItemDescription(e.target.value)}
              fullWidth
              multiline
              rows={4}
              sx={{ mb: 2 }}
            />
            <Box display="flex" justifyContent="flex-end" gap={2}>
              <Button
                variant="outlined"
                color="secondary"
                onClick={handleCancelEdit}
              >
                {t('cancel')}
              </Button>
              <Button
                variant="contained"
                color="primary"
                style={{background:"#50B5FF"}}
                onClick={handleUpdateCategory}
              >
                {t('update')}
              </Button>
            </Box>
          </Box>
        )}
      </Box>
    ))}
  </div>
                </Box>
                
                  ) : (
                    <Typography>{t('no_categories_available')}</Typography>
                  )}
                </Box>
              ) : (
                <Box mt={2}>
                  <Typography variant="h6">{t('create_category')}</Typography>
                  <TextField
                    label={t('category_name')}
                    value={itemName}
                    required
                    onChange={(e) => setItemName(e.target.value)}
                    fullWidth
                    sx={{ mb: 2 }}
                  />
                  <TextField
                    label={t('category_description')}
                    value={itemDescription}
                    required
                    onChange={(e) => setItemDescription(e.target.value)}
                    fullWidth
                    multiline
                    rows={4}
                    sx={{ mb: 2 }}
                  />
                  <Box display="flex" justifyContent="flex-end" gap={2}>
                    <Button
                      variant="outlined"
                      color="secondary"
                      onClick={handleCancelAddCategory}
                    >
                      {t('cancel')}
                    </Button>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={(e) => handleSubmit(e)}
                    >
                      {t('save')}
                    </Button>
                  </Box>
                </Box>
              )}
            </Box>
          </Box>
              )}
              {selectedTab2 === 1 && (
 <Box className="" mt={2}>
 <Box className="condition">
   {!isAddingCondition ? (
     <Box>
       <Box
         display="flex"
         justifyContent="space-between"
         alignItems="center"
       >
         <Typography variant="h6">{t('conditions')}</Typography>
         <Button
           variant="contained"
           color="primary"
           onClick={handleAddCondition}
         >
           {t('add_condition')}
         </Button>
       </Box>

       {conditionAll?.length > 0 ? (
         <Box mt={2} style={{ overflowY: "auto", maxHeight: "50vh" }}>
         {conditionAll?.map((condition, index) => (
           <Box key={index} mb={2} p={2} border={1} borderColor="grey.300">
             <Box display="flex" justifyContent="space-between" alignItems="center">
               <Box>
                 <Typography variant="body2">
                 <Typography variant="body1">
                   <strong>{t('category')}:</strong> {condition?.categoryId?.categoryName}
                 </Typography>
                 <Typography variant="body1">
                   <strong>{t('condition_name')}:</strong> {condition?.conditionName}
                 </Typography>
                   <strong>{t('description')}:</strong> {condition?.conditionDescription}
                 </Typography>
                 {/* {condition.conditionDocuments?.length > 0 && (
                   <Box mt={2}>
                     <Typography variant="body2">
                       <strong>Files:</strong>
                     </Typography>
                     {condition.conditionDocuments.map((doc, docIndex) => (
                       <Box key={docIndex}>
                         <a
                           href={doc}
                           target="_blank"
                           rel="noopener noreferrer"
                         >{`Document ${docIndex + 1}`}</a>
                       </Box>
                     ))}
                   </Box>
                 )} */}
               </Box>
               <Box>
                 <EditIcon
                   style={{ cursor: 'pointer', marginRight: '10px', color: "#50B5FF" }}
                   onClick={() => handleEditCondition(condition)}
                 />
                 <DeleteIcon
                   style={{ cursor: 'pointer', color: "red" }}
                   onClick={() => handleOpenConfirmDialogCondition(condition._id)}
                 />
               </Box>
             </Box>
       
             {editingConditionId === condition._id && (
               <Box mt={2}>
                 <Typography variant="h6" sx={{ mb: 2 }}>{t('update_condition')}</Typography>
                 <FormControl fullWidth sx={{ mb: 2 }}>
                   <InputLabel>{t('category')}</InputLabel>
                   <Select
                     value={selectedCategory}
                     onChange={(e) => setSelectedCategory(e.target.value)}
                     label={t('category')}
                     disabled
                   >
                     {categoryAll?.map((category, index) => (
                       <MenuItem key={index} value={category._id}>
                         {category.categoryName}
                       </MenuItem>
                     ))}
                   </Select>
                 </FormControl>
                 <TextField
                   label={t('condition_name')}
                   value={conditionName}
                   onChange={(e) => setConditionName(e.target.value)}
                   fullWidth
                   sx={{ mb: 2 }}
                 />
                 <TextField
                   label={t('condition_description')}
                   value={description}
                   onChange={(e) => setDescription(e.target.value)}
                   fullWidth
                   multiline
                   rows={4}
                   sx={{ mb: 2 }}
                 />
       
                 {/* <Button
                   variant="outlined"
                   component="label"
                   fullWidth
                   sx={{ mb: 2 }}
                 >
                   <label
                     htmlFor="file-input"
                     style={{ cursor: "pointer", width: "100%" }}
                   >
                     <input
                       id="file-input"
                       type="file"
                       accept="application/pdf"
                       multiple
                       style={{ display: "none" }}
                       onChange={handleFileInputChangeEdit}
                     />
                     <div className="w-100 border-0 text-primary d-flex align-items-center justify-content-center gap-1">
                       <GoUpload /> <span>Upload PDF</span>
                     </div>
                   </label>
                 </Button> */}
       
                 {/* Display newly uploaded files */}
                 {/* <div className="d-flex gap-3">
                   {uploadedFiles?.map((doc, docIndex) => (
                     <div className="d-flex flex-column" key={docIndex}>
                       <Link
                         to={`${doc}`}
                         target="_blank"
                         className="pointer text-dark d-flex flex-column"
                         style={{ fontSize: "10px", textDecoration: "none" }}
                       >
                         <img
                           src={pdf}
                           alt="documents"
                           style={{
                             background: "rgb(221 221 221)",
                             borderRadius: "20px",
                             padding: "10px",
                             width: "50px",
                             height: "50px",
                           }}
                         />
                         {splitFileLink(doc)}
                         <br />
                       </Link>
                     </div>
                   ))}
                 </div> */}
       
                 <Box display="flex" justifyContent="flex-end" gap={2}>
                   <Button
                     variant="outlined"
                     color="secondary"
                     onClick={handleCancelEditCondition}
                   >
                     {t('cancel')}
                   </Button>
                   <Button
                     variant="contained"
                     color="primary"
                     onClick={handleConditionUpdate}
                   >
                     {t('save')}
                   </Button>
                 </Box>
               </Box>
             )}
           </Box>
         ))}
       </Box>
       
       ) : (
         <Typography>{t('no_conditions_available')}</Typography>
       )}

       {/* <Box mt={2} display="flex" justifyContent="flex-end">
           <Button variant="contained" color="primary" onClick={handleProceed}>
             Proceed
           </Button>
         </Box> */}
     </Box>
   ) : (
     <Box mt={2}>
       <Typography variant="h6">{t('create_condition')}</Typography>
       <FormControl fullWidth sx={{ mb: 2 }}>
         <InputLabel>{t('category')}</InputLabel>
         <Select
           // value={selectedCategory}
           onChange={(e) => {
             setCategoryIdForCondition(e.target.value);
           }}
           label={t('category')}
           required
         >
           {categoryAll?.map((category, index) => (
             <MenuItem key={index} value={category._id}>
               {category.categoryName}
             </MenuItem>
           ))}
         </Select>
       </FormControl>
       <TextField
         label={t('condition_name')}
         required
         value={conditionName}
         onChange={(e) => setConditionName(e.target.value)}
         fullWidth
         sx={{ mb: 2 }}
       />
       <TextField
         label={t('condition_description')}
         required
         value={description}
         onChange={(e) => setDescription(e.target.value)}
         fullWidth
         multiline
         rows={4}
         sx={{ mb: 2 }}
         InputLabelProps={{
    shrink: true, // ensures label moves above the field
  }}
  inputProps={{
    style: { padding: "12px" }, // adjust padding so text doesn't overlap label
  }}
       />

       {/* <Button
         variant="outlined"
         component="label"
         fullWidth
         sx={{ mb: 2 }}
       >
         <label
           htmlFor="file-input"
           style={{ cursor: "pointer", width: "100%" }}
         >
           <input
             id="file-input"
             type="file"
             name="image"
             accept="application/pdf"
             multiple
             style={{ display: "none" }}
             onChange={handleFileInputChange}
           />
           <div className="w-100  border-0 text-primary d-flex align-items-center justify-content-center gap-1 ">
             {file ? (
               <>
                 <MdOutlineDone /> <span>Uploaded</span>
               </>
             ) : (
               <>
                 <GoUpload /> <span>Upload PDF</span>{" "}
               </>
             )}{" "}
           </div>
         </label>
       </Button>
       <div className="d-flex gap-3 ">
         {uploadedFiles?.map((doc) => (
           <div className="d-flex flex-column">
             <Link
               to={`${doc}`}
               target="_blank"
               className="pointer text-dark d-flex flex-column"
               style={{ fontSize: "10px", textDecoration: "none" }}
             >
               <img
                 src={pdf}
                 alt="documents"
                 style={{
                   background: "rgb(221 221 221)",
                   borderRadius: "20px",
                   padding: "10px",
                   width: "50px",
                   height: "50px",
                 }}
               />
               {splitFileLink(doc)}
               <br />
             </Link>
           </div>
         ))}
       </div> */}
       <Box display="flex" justifyContent="flex-end" gap={2}>
         <Button
           variant="outlined"
           color="secondary"
           onClick={handleCancelAddCondition}
         >
           {t('cancel')}
         </Button>
         <Button
           variant="contained"
           color="primary"
           onClick={(e) => {
             handleConditionAdd(e);
           }}
         >
                      {t('save')}
         </Button>
       </Box>
     </Box>
   )}
 </Box>
</Box>
              )}
            </Box>

           
          </Box>
        )}


        {step === 5 && (
          <div className="communication-channels">
            <Box
              display="flex"
              flexDirection="column"
              justifyContent="space-between"
              // alignItems="center"
            >
              <Typography variant="h6" style={{marginBottom:"10px"}} mt={1}>{t('communication_channel')}</Typography>
              <div className='d-flex align-items-start justify-content-between' style={{ marginBottom: '20px' }}>
            <div className='d-flex align-items-start gap-2'>
                <Form.Check
                    style={{ width: '15px' }}
                    type="switch"
                    id="custom-switch-sms"
                    checked={communicationChannel.enableSMS}
                    onChange={() => handleToggle('enableSMS')}
                />
                <div className='d-flex align-items-start gap-1'>
                    <TiMessages className='text-primary' style={{ fontSize: '20px' }} />
                    <label>{t('sms')}</label>
                </div>
            </div>
            <div className='d-flex align-items-start gap-2'>
                <Form.Check
                    style={{ width: '15px' }}
                    type="switch"
                    id="custom-switch-email"
                    checked={communicationChannel.enableEmail}
                    onChange={() => handleToggle('enableEmail')}
                />
                <div className='d-flex align-items-start gap-1'>
                    <MdMailOutline style={{ fontSize: '20px', color: '#b33333' }} />
                    <label>{t('mail')}</label>
                </div>
            </div>
            <div className='d-flex align-items-start gap-2'>
                <Form.Check
                    style={{ width: '15px' }}
                    type="switch"
                    id="custom-switch-whatsapp"
                    checked={communicationChannel.enableWhatsapp}
                    onChange={() => handleToggle('enableWhatsapp')}
                />
                <div className='d-flex align-items-start gap-1'>
                    <MdOutlineWhatsapp style={{ fontSize: '20px', color: '#00d500' }} />
                    <label>{t('whatsapp')}</label>
                </div>
            </div>
        </div>
              {/* {!isAddingCredits && (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleAddCreditsClick}
                  style={{width:"200px", marginLeft:"auto"}}
                >
{t('add_credits')}
                </Button>
              )} */}
            </Box>
            <div>
              <Box display="flex" mt={2} style={{ width: "100%" }}>
                {isAddingCredits && (
                  <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="flex-end"
                    gap={2}
                    style={{ width: "100%" }}
                  >
                    <TextField
                      label={t('enter_credits')}
                      value={credits}
                      onChange={(e) => setCredits(e.target.value)}
                      type="number"
                      fullWidth
                      sx={{ mb: 2 }}
                    />
                    <Box display="flex" gap={2}>
                      <Button
                        variant="outlined"
                        color="secondary"
                        onClick={handleCancelAddCredits}
                      >
                        {t('cancel')}
                      </Button>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={handleSaveCredits}
                      >
                    {t('save')}
                      </Button>
                    </Box>
                  </Box>
                )}
              </Box>
            </div>
          </div>
        )}

{step === 6 && (
  <div 
  className="profile-list" 
  style={{
    textAlign: 'center', 
    padding: '20px', 
    // backgroundColor: '#f0f4f8', 
    borderRadius: '10px', 
    // boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
    margin: '20px auto',
    width: '80%'
  }}
>
  <h4 
    style={{
      fontSize: '24px', 
      fontWeight: 'bold', 
      color: '#333',
      margin: '10px 0'
    }}
  >
    {t('all_steps_completed')}
  </h4>
  <h5 
    style={{
      fontSize: '18px', 
      fontWeight: 'normal', 
      color: '#666',
      margin: '10px 0'
    }}
  >
    {t('profile_setup_completed')}
  </h5>
</div>

)}


        <div
          className="step-footer"
          style={{
            gap: "20px",
            display: "flex",
            width: "100%",
            justifyContent: "center",
            marginTop: "10px",
          }}
        >
          <Box
            className="step-footer"
            display="flex"
            justifyContent="center"
            mt={2}
            gap={2}
          >
            {step !== 1 && (
              <Button
                variant="contained"
                color="primary"
                onClick={handleBack}
                style={{ width: "100px", background:"#50B5FF" }}
              >
                {t('back')}
              </Button>
            )}
            {step < 6 ? (
              <Button
                variant="contained"
                color="primary"
                style={{ width: "100px", background:"#50B5FF" }}
                onClick={handleNext}
                disabled={!termsAccepted && step === 1}
              >
                {t('next')}
              </Button>
            ) : (
              <Button
                variant="contained"
                color="primary"
                onClick={handleDone}
                style={{ width: "100px" , background:"#50B5FF"}}
              >
                {t('done')}
              </Button>
            )}
          </Box>
        </div>
      </div>
      )}

      {/* Delete user Profile */}
      <Dialog
      open={openConfirmDialog}
      onClose={handleCloseConfirmDialog}
      PaperProps={{ style: dialogStyles.paper }}
    >
      <DialogTitle>{t('confirm_deletion')}</DialogTitle>
      <DialogContent>
       {t('confirm_delete_user_profile')}
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleCloseConfirmDialog}
          style={buttonStyles.cancelButton}
        >
          {t('cancel')}
        </Button>
        <Button
          onClick={handleDelete}
          style={buttonStyles.deleteButton}
        >
          {t('delete')}
        </Button>
      </DialogActions>
    </Dialog>

    {/* Delete Category */}
    <Dialog
      open={openConfirmDialogCategory}
      onClose={handleCloseConfirmDialog}
      PaperProps={{ style: dialogStyles.paper }}
    >
      <DialogTitle>{t('confirm_deletion')}</DialogTitle>
      <DialogContent>
      {t('confirm_delete_category')}
            </DialogContent>
      <DialogActions>
        <Button
          onClick={handleCloseConfirmDialog}
          style={buttonStyles.cancelButton}
        >
          {t('cancel')}
        </Button>
        <Button
          onClick={handleDeleteCategory}
          style={buttonStyles.deleteButton}
        >
         {t('delete')}
        </Button>
      </DialogActions>
    </Dialog>

    {/* Delete Condition */}
    <Dialog
      open={openConfirmDialogCondition}
      onClose={handleCloseConfirmDialog}
      PaperProps={{ style: dialogStyles.paper }}
    >
      <DialogTitle>{t('confirm_deletion')}</DialogTitle>
      <DialogContent>
      {t('confirm_delete_condition')}
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleCloseConfirmDialog}
          style={buttonStyles.cancelButton}
        >
         {t('cancel')}
        </Button>
        <Button
          onClick={handleDeleteCondition}
          style={buttonStyles.deleteButton}
        >
          {t('delete')}
        </Button>
      </DialogActions>
    </Dialog>
 <div style={{ width: "100%", paddingTop: "20px" }}>
  <div
    style={{
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "space-evenly",
      alignItems: "center",
      gap: "10px",
      margin: 0,
      padding: 0,
    }}
  >
    {available?.dynamicQRC?.available >= 0 && (
      <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
        <strong>{t("availableQrc")}:</strong>
        <span>{available?.dynamicQRC?.available}</span>
      </div>
    )}

    {available?.sms?.available >= 0 && (
      <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
        <strong>{t("availableSms")}:</strong>
        <span>{available?.sms?.available}</span>
      </div>
    )}

    {available?.whatsapp?.available >= 0 && (
      <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
        <strong>{t("availableWhatsapp")}:</strong>
        <span>{available?.whatsapp?.available}</span>
      </div>
    )}
  </div>
</div>

    </div>
    </>
  );
};

const styles = {
  loaderOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.6)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999,
  },
};

export default Stepper;
